import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "poll-quiz-container"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_poll_quiz_statistics = _resolveComponent("poll-quiz-statistics");
  const _component_quiz_checkable_text_question = _resolveComponent("quiz-checkable-text-question");
  const _component_quiz_readonly_alert = _resolveComponent("quiz-readonly-alert");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_ctx.question ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_ctx.isResultMode ? (_openBlock(), _createBlock(_component_poll_quiz_statistics, {
    key: 0,
    "poll-results-id": _ctx.pollResultsId,
    "quiz-statistics-data-input": _ctx.quizStatisticsData,
    "user-answers-ids": _ctx.userRealtimeAnswersIds,
    "has-result-label": true
  }, null, 8, ["poll-results-id", "quiz-statistics-data-input", "user-answers-ids"])) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createVNode(_component_quiz_checkable_text_question, {
    class: "survey-quiz-question",
    question: _ctx.question,
    selected: _ctx.userAnswers(_ctx.question),
    onSelectionChange: _ctx.onSelectionChange
  }, null, 8, ["question", "selected", "onSelectionChange"]), _ctx.canEdit ? (_openBlock(), _createBlock(_component_quiz_readonly_alert, {
    key: 0,
    "is-speach-template": _ctx.isSpeachTemplate
  }, null, 8, ["is-speach-template"])) : _createCommentVNode("", true)], 64))], 64)) : _createCommentVNode("", true)]);
}